import { QuestionHotelPolicyI18nBase } from "./base/root";
import { QuestionReservationAdditionalFeeSettings } from "./reservaion-additional-fee/root";
import { QuestionReservationQuestionSettings } from "./reservation-questions/root";

import type { HotelPolicyI18nCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	hotelPolicyI18nCategoriesAndManagerStore: HotelPolicyI18nCategoriesAndManagerStore;
};

export const HotelPolicyI18nForm = ({ hotelPolicyI18nCategoriesAndManagerStore }: Props) => {
	const { base, reservationQuestionSettings, reservationAdditionalFeeSettings } =
		hotelPolicyI18nCategoriesAndManagerStore;

	return (
		<>
			<QuestionHotelPolicyI18nBase base={base} />
			<QuestionReservationQuestionSettings reservationQuestionSettings={reservationQuestionSettings} />
			<QuestionReservationAdditionalFeeSettings
				reservationAdditionalFeeSettings={reservationAdditionalFeeSettings}
			/>
		</>
	);
};

HotelPolicyI18nForm.displayName = "HotelPolicyI18nForm";
